import { Icon } from '@frontend/icons';
import { NakedButton, Text } from '@frontend/design-system';
import { styles, variantStyles } from './styles';
import { QuickFilterListItem, QuickFilterKey, QuickFilterCardVariant } from './types';

type Props = {
  variant?: QuickFilterCardVariant;
  list: QuickFilterListItem[];
  onSelect: (filter: QuickFilterKey) => void;
  onRemove?: (filter: QuickFilterKey) => void;
};

export const QuickFilterCards = ({ variant = 'card', list, onSelect, onRemove }: Props) => {
  return (
    <div css={styles.root}>
      {list.map((item) => (
        <NakedButton
          key={item.label}
          css={styles.item(variant, item.isActive)}
          trackingId={item.trackingId}
          onClick={() => {
            if (item.isActive) return;
            onSelect(item.key);
          }}
        >
          {variant === 'compactCard' ? (
            <>
              {Number(item.count) > 0 && (
                <div css={styles.countBadge}>
                  <Text size='small' weight='bold' color='white'>
                    {item.count}
                  </Text>
                </div>
              )}
            </>
          ) : (
            <>
              <Icon name={item.iconName} size={16} color='subdued' css={{ flexShrink: 0 }} />
              <Text size='medium' weight='bold'>
                {item.count}
              </Text>
            </>
          )}
          <Text size={variantStyles[variant].textSize} color={variantStyles[variant].textColor}>
            {item.label}
          </Text>
          {variant === 'compactCard' && item.isActive && (
            <NakedButton
              css={{ display: 'flex', flexShrink: 0 }}
              onClick={(event) => {
                event.stopPropagation();
                onRemove?.(item.key);
              }}
            >
              <Icon name='x-tiny' color={'default'} />
            </NakedButton>
          )}
        </NakedButton>
      ))}
    </div>
  );
};
